import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { ContactDetailsPropTypes, PolicyHolderPropTypes } from '../../../propTypes/petDetails';
import { SuccessMessageDialog } from '../../successMessage/successMessageDialog';
import { CSPUrlsMap } from '../../../routes/CSPUrlsMap';
import { BrandContext } from '../../../contextProviders/brandContext';
import { AUTHENTICATION_TYPES, SUCCESS_MESSAGES } from '../../../constants/constants';
import { UpdateContactDetailsPopup } from '../../accountDetails/policyHolderDetails/contactDetails/updateContactDetailsModal';
import useStepupChallenge from '../../../hooks/useStepupChallenge';

export const DigitalPreference = ({ policyHolder, fieldFormContext, contactDetails }) => {
  const { authenticationType } =
    useContext(BrandContext).activeBrandContext.cspConfiguration.auth0Config[process.env.REACT_APP_ENV];
  const isSsoAuthentication = authenticationType === AUTHENTICATION_TYPES.SSO;
  const [showContactDetailsModal, setShowContactDetailsModal] = useState(false);

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const { stepUpSmsChallenge } = useStepupChallenge();

  const handleUpdateEmail = () => {
    if (isSsoAuthentication) {
      setShowContactDetailsModal(true);
    } else {
      stepUpSmsChallenge(`${window.location.origin}${CSPUrlsMap.updateEmail.url}`, true);
    }
  };

  return (
    <section className="digitalPreference">
      <div className="emailValue">
        <span className="labelValueText">
          <em>Email address</em>
          <strong>{policyHolder.email}</strong>
        </span>

        <button
          type="button"
          onClick={handleUpdateEmail}
          className="button primary outline"
        >
          <Icon icon="pencil" />
          <span className="labelText">Update</span>
        </button>
      </div>

      {showContactDetailsModal && (
        <UpdateContactDetailsPopup
          policyHolder={policyHolder}
          setShowContactDetailsModal={setShowContactDetailsModal}
          setShowSuccessMessage={setShowSuccessMessage}
          showMobileField={false}
        />
      )}

      {showSuccessMessage && (
        <SuccessMessageDialog
          message={SUCCESS_MESSAGES.UPDATE_EMAIL}
          onClose={() => setShowSuccessMessage(false)}
        />
      )}
    </section>
  );
};

DigitalPreference.propTypes = {
  policyHolder: PolicyHolderPropTypes,
  // eslint-disable-next-line react/forbid-prop-types
  fieldFormContext: PropTypes.any,
  contactDetails: ContactDetailsPropTypes
};
